import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { get } from "lodash";

export const gameServingOrder = [
  "b1",
  "b4",
  "b2",
  "b3",
  "b4",
  "b2",
  "b3",
  "b1",
  "b2",
  "b3",
  "b1",
  "b4",
  "b3",
  "b1",
  "b4",
  "b2",

  "b1",
  "b4",
  "b3",
  "b2",
  "b4",
  "b2",
  "b1",
  "b3",
  "b4",
];

export const demoServingOrder = ["b2"];

export const ingredientSlice = createSlice({
  name: "ingredients",
  initialState: {
    timer: moment(),
    points: 0,
    served: 0,
    moves: 0,
    discarded: 0,
    correctServed: 0,
    servingOrder: demoServingOrder,
    burgerTray: [
      {
        ingredients: [],
        discountPoint: "0",
      },
      {
        ingredients: [],
        discountPoint: "0",
      },
      {
        ingredients: [],
        discountPoint: "0",
      },
    ],
    burgerQueue: [],

    grillQueue: [null, null, null],
    startTime: null,
    endTime: null,

    burntPatty: 0,
    correctIngredientsPlaced: 0,
    totalIngredientsPlaced: 0,
    pattiesPlaced: 0,
    bunsPlaced: 0,
    pattiesTrashed: 0,

    isDemo: true,
  },

  reducers: {
    setTimer(state, action) {
      state.timer = action.payload;
    },
    setStartTime(state, action) {
      state.startTime = action.payload;
    },
    setEndTime(state, action) {
      state.endTime = action.payload;
    },
    setPoints(state, action) {
      state.served = state.served + 1;
      state.points = state.points + action.payload;
    },
    setServed(state, action) {
      state.served = action.payload;
    },
    setCorrectServed(state, action) {
      state.correctServed = state.correctServed + 1;
    },
    pushInBurgerQueue(state, action) {
      state.burgerQueue.push(action.payload);
    },
    pushInGrillQueue(state, action) {
      state.grillQueue.push(action.payload);
    },
    shiftBurgerQueue(state, action) {
      state.burgerQueue.shift();
    },
    shiftBurgerOrder(state, action) {
      state.servingOrder.shift();
    },
    updateGrillQueue(state, action) {
      const duplicateGrillQueue = [...state.grillQueue];
      duplicateGrillQueue[action.payload.index] = action.payload.value;
      state.grillQueue = duplicateGrillQueue;
    },
    removefromGrillQueue(state, action) {
      const tempQueue = [...state.grillQueue];
      tempQueue[action.payload.index] = null;
      state.grillQueue = tempQueue;
    },

    updateBurgerTray(state, action) {
      const duplicateBurgerTray = [...state.burgerTray];
      duplicateBurgerTray[action.payload.index] = action.payload.value;
      state.burgerTray = duplicateBurgerTray;
    },
    discardBurger(state, action) {
      const duplicateBurgerTray = [...state.burgerTray];
      duplicateBurgerTray[action.payload] = {
        ingredients: [],
        discountPoint: "0",
      };
      state.discarded = state.discarded + 1;
      state.burgerTray = duplicateBurgerTray;
    },
    increaseMoves(state, action) {
      state.moves = state.moves + 1;
    },
    increasePattiesPlaced(state, action) {
      state.pattiesPlaced += 1;
    },
    increaseBunsPlaced(state, action) {
      state.bunsPlaced += 1;
    },
    increasePattiesTrashed(state, action) {
      state.pattiesTrashed += 1;
    },
    resetAll(state, action) {
      state.timer = moment();
      // state.servingOrder = get(action, 'payload.isDemo', false) == true ? demoServingOrder : gameServingOrder;
      state.servingOrder = gameServingOrder;
      state.burgerTray = [
        {
          ingredients: [],
          discountPoint: "0",
        },
        {
          ingredients: [],
          discountPoint: "0",
        },
        {
          ingredients: [],
          discountPoint: "0",
        },
      ];
      state.burgerQueue = [];
      state.grillQueue = [null, null, null];
      state.isDemo = get(action, "payload.isDemo", false);

      state.burntPatty = 0;
      state.points = 0;
      state.served = 0;
      state.correctServed = 0;
      state.correctIngredientsPlaced = 0;
      state.totalIngredientsPlaced = 0;
      state.pattiesPlaced = 0;
      state.bunsPlaced = 0;
      state.pattiesTrashed = 0;
    },
    resetState(state, action) {
      state.moves = 0;
      state.points = 0;
      state.served = 0;
      state.correctServed = 0;
    },
    updateBurntPatty(state, action) {
      if (action.payload.burnt) state.burntPatty = state.burntPatty + 1;
      else state.burntPatty = 0;
    },
    updateCorrectIngredientsPlaced(state, action) {
      if (get(action, "payload.correctIngredients", 0) > 0) {
        state.correctIngredientsPlaced =
          state.correctIngredientsPlaced + action.payload.correctIngredients;
      }
    },
    updateTotalIngredientsPlaced(state, action) {
      if (get(action, "payload.totalIngredients", 0) > 0) {
        state.totalIngredientsPlaced =
          state.totalIngredientsPlaced + action.payload.totalIngredients;
      }
    },

    updateBurgerQueueWhenDropped(state, action) {
      let tempState = state.burgerQueue;
      tempState.splice(action.payload.dropPointIndex, 1);
      state.burgerQueue = tempState;
    },

    setIsDemo(state, action) {
      if (get(action, "payload.isDemo", false)) {
        switch (action.payload.isDemo) {
          case "1":
            state.isDemo = true;
            break;
          case "0":
            state.isDemo = false;
            break;
          default:
            state.isDemo = true;
        }
      } else {
        state.isDemo = true;
      }
    },
  },
});
export const {
  setTimer,
  setPoints,
  setServed,
  setCorrectServed,
  setStartTime,
  setEndTime,
  pushInBurgerQueue,
  shiftBurgerQueue,
  shiftBurgerOrder,
  updateGrillQueue,
  removefromGrillQueue,
  updateBurgerTray,
  resetAll,
  pushInGrillQueue,
  increaseMoves,
  discardBurger,
  resetState,
  updateBurntPatty,
  updateCorrectIngredientsPlaced,
  updateTotalIngredientsPlaced,
  updateBurgerQueueWhenDropped,
  setIsDemo,
  increasePattiesPlaced,
  increaseBunsPlaced,
  increasePattiesTrashed,
} = ingredientSlice.actions;

export default ingredientSlice.reducer;
